import settingsLanguage from './settingsLanguage.json';
import createNew from './createNew.json';
import switchUser from './switchUser.json';

export const enGB = {
  settingsLanguage,
  createNew,
  switchUser,
};
